import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from "react-router-dom";
import './App.css';
import ReservForm from "./components/ReservFormUpload";
import CVSTab from "./components/CVSReserve";
import LostReportForm from "./components/lostreportform";

const menu = [
  {
    key: "catalogtool",
    label: "編目工具",
    children: [
      { key: "catalog/barcodelabel", label: "條碼標籤產生" },
    ]
  },
  {
    key: "reservtool",
    label: "預約書處理",
    children: [
      { key: "circulation/interlibreserv", label: "列印找書單" },
    ]
  },
  {
    key: "cvstool",
    label: "超商取書",
    children: [
      { key: "circulation/cvstransit", label: "列印超商取書單據" },
    ]
  },
  {
    key: "formtool",
    label: "常用表單",
    children: [
      //{ key: "circulation/lostbookform", label: "賠書單(書不見或損壞)"},
      //{ key: "circulation/claimreturnform", label: "讀者聲稱已還"}
    ]
  }
];

function Navbar({ current, setCurrent }) {
  const navigate = useNavigate();
  const [openMenu, setOpenMenu] = useState(null);
  const [hovered, setHovered] = useState(null);

  return (
    <nav style={{
      background: "#007bff",
      color: "#fff",
      padding: "12px 24px",
      display: "flex",
      alignItems: "center",
      gap: 16,
      fontSize: 18,
      position: "relative"
    }}>
      <img src="/favicon.ico" alt="logo" style={{ width: 32, height: 32, marginRight: 0, cursor: "pointer" }} onClick={() => {
        setCurrent("home");
        navigate("/");
        setOpenMenu(null);
      }}/>
      <span
        style={{ fontWeight: "bold", cursor: "pointer", marginRight: 32 }}
        onClick={() => {
          setCurrent("home");
          navigate("/");
          setOpenMenu(null);
        }}
      >
        南市圖館員工具箱
      </span>
      {menu.map(main => (
        <div
          key={main.key}
          style={{ position: "relative", display: "inline-block" }}
          onMouseEnter={() => setOpenMenu(main.key)}
          onMouseLeave={() => { setOpenMenu(null); setHovered(null); }}
        >
          <span style={{ marginRight: 8, cursor: "pointer" }}>{main.label}</span>
          {openMenu === main.key && (
            <div style={{
              position: "absolute",
              top: "100%",
              left: 0,
              background: "#0056b3",
              borderRadius: 4,
              boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
              zIndex: 10,
              minWidth: 120,
              padding: "4px 0"
            }}>
              {main.children.map(sub => (
                <button
                  key={sub.key}
                  style={{
                    ...navBtnStyle(current === sub.key, hovered === sub.key),
                    display: "block",
                    width: "100%",
                    textAlign: "left",
                    padding: "10px 16px",
                  }}
                  onClick={() => {
                    setCurrent(sub.key);
                    navigate(`/${sub.key}`);
                    setOpenMenu(null);
                  }}
                  onMouseEnter={() => setHovered(sub.key)}
                  onMouseLeave={() => setHovered(null)}
                >
                  {sub.label}
                </button>
              ))}
            </div>
          )}
        </div>
      ))}
    </nav>
  );
}

function navBtnStyle(active, hovered) {
  let bg = "transparent";
  if (active) bg = "#003d80";
  else if (hovered) bg = "#1976d2";
  return {
    background: bg,
    color: "#fff",
    border: "none",
    cursor: "pointer",
    borderRadius: 4,
    fontWeight: active ? "bold" : "normal"
  };
}

function CurrentPathLabel() {
  const location = useLocation();
  const path = location.pathname.replace(/^\//, ""); // 去掉開頭的 "/"
  const label = getCurrentLabel(path || "home");
  return <span>　目前位置：{label}</span>;
}

function getCurrentLabel(current) {
  if (current === "home") return "首頁";
  for (const main of menu) {
    for (const sub of main.children) {
      if (sub.key === current) {
        return `${main.label} > ${sub.label}`;
      }
    }
  }
  return "";
}

// 根據 current key 取得頁面 title
function getPageTitle(current) {
  if (current === "home") return "南市圖館員工具箱";
  for (const main of menu) {
    for (const sub of main.children) {
      if (sub.key === current) {
        return `${sub.label} - 南市圖館員工具箱`;
      }
    }
  }
  return "南市圖館員工具箱";
}

function getSessionId() {
  let sessionId = sessionStorage.getItem("session_id");
  if (!sessionId) {
    sessionId = crypto.randomUUID();
    sessionStorage.setItem("session_id", sessionId);
  }
  return sessionId;
}

function App() {
  const sessionId = getSessionId();
  return (
    <Router>
      <AppContent sessionId={sessionId} />
    </Router>
  );
}

function AppContent({ sessionId }) {
  const location = useLocation();
  const [current, setCurrent] = useState("home");

  useEffect(() => {
    const path = location.pathname.replace(/^\//, "");
    document.title = getPageTitle(path || "home");
  }, [location]);

    useEffect(() => {
    console.log(`  ⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢀⣠⡤⠤⠤⣤⣄⡀⠀⠀⢀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣠⡾⠛⠁⠀⠀⠀⣀⣤⠿⠿⠟⣉⣛⣟⣛⣷⡒⢤⣄⡀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣴⠟⠀⠀⠀⠀⣠⠞⣱⠋⢀⣤⡺⠿⣿⢟⣿⡧⣯⣻⣽⣿⠷⣦⣄⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣼⠇⠀⠀⠀⣰⡊⣡⠞⢁⣴⣿⢛⣓⡾⣿⡟⣧⡀⢸⣿⡟⣾⣧⣺⡛⣿⣖⠲⢦⣀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣼⠃⠀⢀⠐⢚⡧⠞⠁⣰⣿⡿⢫⣿⢏⣾⣿⣧⣎⣟⣼⠿⠿⠟⢋⣄⣳⢰⢿⡀⠀⢹⣷⣄⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠙⠒⢛⣿⣿⠉⠀⠀⣼⡿⣼⣧⣿⣧⡟⣿⡁⠀⠹⠋⠙⣆⣴⣾⡿⠟⠉⢿⡇⡇⠀⠀⠛⢻⡄⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢠⣾⣿⢵⡂⢀⣿⡿⣽⣿⣿⢿⠏⢰⡟⣧⡄⢀⡆⣰⣿⡄⣠⣴⣾⡟⢛⡇⡇⠀⠀⠀⢸⡇⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢠⣿⣿⣿⡏⠀⢸⡟⣼⣿⠋⣾⣯⣄⣸⢧⣿⡟⣾⢽⣿⡇⢹⣿⣿⣄⣇⠀⢷⢸⠆⠀⠀⠀⡇⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣰⣿⡿⣿⣾⠁⡎⢸⣹⣿⠃⢐⣿⠀⠀⣿⣸⠀⠃⠃⡾⣿⣀⠸⣿⣿⡏⡿⢠⠸⡌⣇⠂⠀⠀⡇⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢠⣾⣿⠏⣸⣿⢸⠀⣷⢸⣿⠃⠀⠸⣿⡀⠀⣿⣿⠀⠀⣸⣷⠃⠉⢹⡏⣿⢇⡇⠀⠀⢹⣼⣷⡄⢰⡇⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣠⣶⣿⣿⣧⣰⣿⣿⢸⡄⢸⣼⣷⡶⠶⢶⣤⡈⠂⣿⣿⣤⢠⣿⠃⠀⠀⢸⠁⢸⣼⡿⠁⡀⣸⣾⡿⢯⣼⠇⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⡤⠴⠶⠿⣻⣿⣿⣿⣿⠁⡿⢸⢸⣇⠀⢿⣷⡀⠀⠀⠈⠙⠀⠘⠻⣿⡿⢉⣉⣉⣠⠇⠀⢸⣿⠁⢠⢇⡏⢹⠇⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⢀⣾⣿⣿⣹⣿⡇⣰⣿⠸⣿⡿⣆⢈⢯⠛⠆⠀⠀⠀⠀⠀⠀⠀⠀⠈⠉⠉⠛⢷⣄⡼⡋⠀⡼⣸⢻⢸⡀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⢀⣾⣿⣫⣯⡿⣟⣷⡸⣿⣿⢻⣷⣿⣿⣮⣧⡀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢀⣿⠟⢁⣼⣱⠏⣸⢸⡇⠀⠀⠀⠀⠀⠀⠀⢀⡀
⠀⠀⠀⠀⠀⠀⠀⢸⡞⠁⢸⡾⠀⣿⣿⡄⣿⣿⢸⣿⣿⣌⠻⠯⠛⠂⠘⠒⠒⠤⣀⣀⠀⠀⠀⣠⣾⠟⠁⣠⢞⣼⢿⣸⣿⣿⣧⠀⠀⠀⠀⠀⠀⠀⠈⠁
⠀⠀⠀⠀⠀⠀⠀⢸⡄⠀⢺⡇⠀⢹⣿⣳⢷⢸⣿⢻⣿⣿⣦⡀⠀⠀⠀⠀⠀⠀⠈⠁⠀⠀⣠⠼⠋⣠⡼⣿⡾⣿⣾⣿⣿⣿⢿⡆⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠈⢷⡀⠈⢿⣿⣼⣾⣿⡿⣿⣿⣿⣿⢦⡀⠀⠀⠀⠀⠀⠀⠐⢿⣧⣶⣿⣿⢿⣿⡿⣿⣿⣿⣿⣿⠈⠻⣄⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠙⠶⣬⣿⣿⣿⣟⢱⡿⠛⠉⡸⠀⠈⠓⠦⠤⠤⣶⢶⣿⡏⢹⣿⣿⢏⣿⢿⣿⣿⣿⡿⢸⣿⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⢠⣿⣿⣿⣿⣿⠀⣤⣇⠀⠀⠀⠀⠀⠀⣏⡀⠻⣿⣼⡿⣿⣾⣣⣿⣿⣿⣿⠃⢸⡏⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⣀⣤⡴⠚⣿⣿⣿⣿⣅⡤⠿⠿⣿⣿⣿⣿⣿⣿⣿⣃⣀⣈⣷⣷⣿⣻⣿⣿⣿⠿⠁⢠⡟⠁⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⠀⠀⣀⡠⠴⠖⠛⠉⠀⠀⠀⢸⣿⣿⣿⠀⠀⠀⠀⠀⣬⠿⢧⠀⠀⠀⠈⠙⣿⣿⣿⣿⣿⠿⣯⣤⣤⠔⠋⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⢠⡶⠋⠁⠀⠀⠀⠀⠀⠀⠀⠀⡜⢿⣿⡇⠠⠍⠀⠀⠰⣿⣶⣾⡧⠀⠀⢀⣠⣿⣿⣿⣿⣿⠀⠀⣿⡆⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠈⡿⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⡇⣸⣿⣇⠀⠀⠀⠀⠀⠈⠉⠋⠀⠀⠀⠀⢸⢿⣿⣿⠟⠃⠀⢀⣿⠉⢦⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⠀⣹⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⡇⣿⣿⣿⡀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⡞⣾⣿⠁⠀⠀⣀⣾⡟⠀⠀⢇⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⢠⡏⣇⠀⠀⠀⠀⠀⠀⠀⠀⠀⢳⣿⣿⣼⣧⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⡼⣽⣿⡿⡄⠀⡿⡷⠋⠀⠀⠀⢸⡆⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⠀⡸⠃⠸⡄⠀⠀⠀⠀⠀⠀⠀⢨⣿⣿⣧⢿⠋⢧⣄⡀⠀⠀⠀⠀⠀⠀⡼⠁⣿⣿⣿⡇⠀⡇⣿⡀⠀⠀⠀⠀⢳⣤⣀⠀⠀⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⢀⡿⠀⠀⢱⡀⠀⠀⠀⠀⠀⠀⢸⠘⣿⣽⣾⣇⠈⠻⣿⣷⣦⣴⣶⣿⠟⠁⠀⣿⡟⣿⣇⣼⡝⠀⢣⠀⠀⠀⠀⠸⡆⣝⠷⣄⠀⠀⠀⠀⠀⠀⠀
⠀⠀⠀⢸⡇⠀⠀⠀⢣⡀⠀⠀⠀⠀⠀⢸⠀⠈⠻⢿⣿⣦⣤⣿⣿⣿⣿⣿⣁⡀⠀⠀⣿⣿⣿⠿⠋⠀⠀⠈⡆⠀⠀⠀⠀⢧⡞⠀⢺⣆⠀⠀⠀⠀⠀⠀
⠀⠀⢀⡟⠀⠀⠀⠀⢸⢧⡀⠀⠀⠀⠀⠈⡄⠀⠀⠀⠀⠉⠁⠀⢨⣶⣾⡍⠛⠿⠟⢻⣿⣿⣿⢄⠀⣀⠖⢆⢱⠀⠀⠀⠀⣼⠁⠀⠀⠻⣧⡀⠀⠀⠀⠀
⠀⠀⣸⠃⠀⠀⠀⠀⢸⠀⢻⣆⠀⠀⠀⠀⡇⠀⠀⠀⠀⠀⠀⠀⠀⠉⢹⠀⠀⠀⠸⠟⠉⣁⣨⢟⣫⣵⡋⠉⢸⠀⠀⠀⢀⣏⠂⠀⠀⠀⠈⢷⡄⠀⠀⠀
⢀⣀⡇⠀⠀⠀⠀⠀⢸⠀⠀⢻⣄⠀⠀⠀⡇⠀⠀⠀⠀⠀⠀⠀⠀⠀⢻⠀⠀⠀⠀⠀⠈⢷⡔⠉⠈⠳⣯⡗⢸⠀⠀⠀⡞⠁⠀⠀⠀⠀⠀⠀⠙⢄⠀⠀
⢸⣿⣾⣷⠀⠀⠀⠀⢸⠀⠀⠀⠻⣆⠀⠀⢸⠀⠀⠀⠀⠀⠀⠀⢾⣽⡏⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠉⠀⡇⠀⠀⡸⠁⠀⠀⠀⠀⠀⠀⠀⠀⠈⣣⡀
⢸⣿⢥⡏⠀⠀⠀⠀⠘⡄⠀⠀⠀⠘⣧⣀⠘⡆⠀⠀⠀⠀⠀⠀⠀⠀⠃⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⠀⡼⠀⠀⣰⠃⠀⠀⠀⠀⠀⠀⠀⠀⠀⢀⣼⠇`)
  }, []);

  return (
    <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Navbar current={current} setCurrent={setCurrent}/>
      <div style={{
        background: "#007bff",
        padding: "0 0 0 0",
        textAlign: "left",
        fontSize: 16,
        color: "#fff",
      }}>
        <CurrentPathLabel />
      </div>
      <div
        style={{
          //minHeight: "80vh",
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Routes>
          <Route path="/" element={<h1>請從上方選單選擇功能</h1>} />
          <Route path="/catalog/barcodelabel" element={<div>條碼標籤產生功能元件（待實作）</div>} />
          <Route path="/circulation/interlibreserv" element={<ReservForm />} />
          <Route path="/circulation/cvstransit" element={<CVSTab sessionId={sessionId} />} />
          <Route path="/circulation/lostbookform" element={<LostReportForm />} />
          <Route path="/circulation/claimreturnform" element={<h1>無權限存取</h1>} />
        </Routes>
      </div>
      <footer>
        <div style={{ padding: "1rem", textAlign: "center" }}>
          <p>南市圖館員工具箱. All rights reserved.<br />
            使用上若有問題，歡迎來信：<a href="mailto:lch@lch.tw">lch@lch.tw</a>
          </p>
        </div>
      </footer>
    </div>
  );
}

export default App;
